/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
const trackingUtils = require('../utils/tracking.utils');
const trackingLabels = {
    tripadvisor: 'tripadvisor_score',
    price: 'price_range',
    neighbourhood: 'hotel_neighborhood',
    accommodationType: 'accommodation_type',
    location: 'situation',
    category: 'hotel_rating',
    hotelName: 'hotel_name',
    ourSelection: 'hotels_list',
};

module.exports = Odigeo.View.extend({
    events: {
        'tap .accommodation_filter_tab': 'onChangeTab',
    },
    selectors: {
        filtersContainer: '.accommodation_filter_container',
    },

    init() {
        this.widget.subscribers = this.findSubscribers();
        this.bindFilterSubscribers();
    },

    bindFilterSubscribers: Odigeo._.once(function() {
        this.$el.on('filterHasChanged.accommodationfilter', this.model.onFilterHasChanged.bind(this.model));
        this.$el.on('requestFilterStatus.accommodationfilter', this.model.onUpdateFilterStatus.bind(this.model));
    }),

    findSubscribers() {
        return Odigeo._.filter(this.$el.find('[data-widget]').toArray(), function(el) {
            return $(el).attr('id').indexOf('filter') !== -1;
        });
    },

    onChangeTab(ev) {
        var $el = $(ev.currentTarget);
        var tab = $el.attr('data-tab');
        this.$el.find(this.selectors.filtersContainer).attr('data-active-tab', tab);
        trackingUtils.trackEvent('results_filters_hotels', 'open_' + trackingLabels[tab]);
        Odigeo.trigger(this.widget.id + ':tabChanged', tab);
    },

    cleanFilterTag(tag) {
        $(this.getSubscriber(tag.type)).trigger('resetFilterStatus.accommodationfilter', tag.name);
    },

    getSubscriber(filterType) {
        return Odigeo._.find(this.widget.subscribers, function(subscriber) {
            return $(subscriber).data('widget') === Odigeo._.snakeCase(filterType);
        });
    },

    showContainer() {
        this.$el.find(this.selectors.filtersContainer).removeClass('odf-hidden');
    },

    hideContainer() {
        this.$el.find(this.selectors.filtersContainer).addClass('odf-hidden');
    },
});
